import { ApiFile } from '@hooks';
import { useState } from 'react';

export const useFileUploader = () => {
    const [fileModalOpen, setFileModalOpen] = useState<ApiFile>();

    const handleOpenFileModal = (file: ApiFile) => {
        setFileModalOpen(file);
    };

    const handleCloseFileModal = () => {
        setFileModalOpen(undefined);
    };

    return { fileModalOpen, handleOpenFileModal, handleCloseFileModal };
};
